export default __webpack_public_path__ + "static/media/empty-cart.6a5459d0.jpg";